import { Button, Typography } from "@uhc-tempo/components";
import useSelectedBenefits from "../../features/shopping/use-selected-benefits";
const { H6 } = Typography;

function FeaturedBenefit({ image, headline, body, link, linkText }) {
  return (
    <div className="shopping-featured-benefit__card ua-display-flex ua-flex-column ua-bg-primary-three ua-border-radius-md">
      {image ? (
        <div
          className="shopping-featured-benefit__card__image ua-border-radius-top-md"
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
      ) : null}
      <div className="shopping-featured-benefit__card__tag ua-bg-primary-two ua-text-primary-three ua-font-sans ua-width-fit-content">
        {headline}
      </div>
      <div className="shopping-featured-benefit__card__content ua-padding-lg-horizontal ua-padding-xxlg-bottom ua-flex-grow ua-display-flex ua-flex-column">
        <div className="shopping-featured-benefit__card__label ua-text-accent-one ua-font-sans">
          <span>
            Included{" "}
            <em style={{ fontWeight: "normal" }}>(no points required)</em>
          </span>
        </div>
        <H6 className="ua-line-clamp-sm-2 ua-flex-grow">{body}</H6>
        <Button
          buttonType={`secondary-one`}
          className="ua-text-nowrap ua-width-fit-content"
          onClick={() => {
            window.open(link, "_blank");
          }}
        >
          {linkText}
        </Button>
      </div>
    </div>
  );
}

export default function IndividualShoppingCallouts() {
  let {
    medicalNetChange,
    specialtyNetChange,
    medicalSubscribers,
    manuallyAllowedShopping,
    medicalRequired,
    specialtyRequired,
    subscribersRequired,
  } = useSelectedBenefits();

  if (manuallyAllowedShopping) {
    return null;
  }
  return (
    <div className="scorecard">
      <div className="w-full">
        <div className="scorecard-teal">2026 UA SCORECARD</div>
        <h1>
          This is how your agency <span className="accent">achieved</span> UA
          Status
        </h1>
      </div>
      <div className="ua-flex-row flex">
        <div className="scorecard-item ua-flex-column">
          <div className="scorecard-teal scorecard-item-header">
            {medicalSubscribers}
          </div>
          <div className="scorecard-item-title">Medical subscribers</div>
          <div className="scorecard-item-value">
            {subscribersRequired} required
          </div>
        </div>
        <div className="scorecard-item ua-flex-column">
          <div className="scorecard-teal scorecard-item-header">
            {medicalNetChange}%
          </div>
          <div className="scorecard-item-title">Medical net change</div>
          <div className="scorecard-item-value">
            {medicalRequired}% required
          </div>
        </div>
        <div className="scorecard-item ua-flex-column">
          <div className="scorecard-teal scorecard-item-header">
            {specialtyNetChange}%
          </div>
          <div className="scorecard-item-title">Specialty net change</div>
          <div className="scorecard-item-value">
            {specialtyRequired}% required
          </div>
        </div>
      </div>
    </div>
  );

  // const featuredBenefits = [
  //   {
  //     headline: "CE COURSES",
  //     body: "Stay up-to-date with 25+ complimentary courses.",
  //     link: "https://www.netstudy.com/uhc/insurance/courses/catalog",
  //     linkText: "View options",
  //     image: "/images/ce-courses.png",
  //   },
  //   {
  //     headline: "ON-DEMAND TRAINING",
  //     body: "24/7 access to relevant industry training.",
  //     link: "https://unitedadvantage.com/training-resources",
  //     linkText: "See library",
  //     image: "/images/on-demand.png",
  //   },
  //   {
  //     headline: "COMPANIES LIKE ME",
  //     body: "Benchmark tool for dental and medical products.",
  //     link: "https://www.companieslikeme.com/",
  //     linkText: "Run a report now",
  //     image: "/images/companies-like-me.png",
  //   },
  // ];
  // return (
  //   <>
  //     {featuredBenefits.map((benefit, i) => (
  //       <div key={i} className={`ua-flex-col-3-up-md`}>
  //         <FeaturedBenefit {...benefit} />
  //       </div>
  //     ))}
  //   </>
  // );
}
